/**
 * Gala WebP/JXL guard, rete di sicurezza a runtime.
 *
 * La cache Cloudflare davanti a galagloves.it a volte serve image/jxl (JPEG XL)
 * anche a browser che non lo decodificano (Chrome/Firefox/Edge): immagine rotta.
 * Succede per qualunque URL del CDN Shopify che non sia format=pjpg, non solo
 * format=webp: il 29/09/2026 erano rotti i campioni colore con format=jpg e
 * quelli senza format (Deep Red, Black/White, Pink nelle card collezione).
 * Il tema usa pjpg ovunque possibile; questo guard copre i punti residui
 * (app terze, embed, snippet futuri scritti senza la regola pjpg).
 *
 * Comportamento: al primo error su un <img> del CDN Shopify riscrive src e
 * srcset con format=pjpg (sostituendo il format esistente o aggiungendolo).
 * Un solo tentativo per immagine (dataset) per evitare loop. All'avvio
 * ripassa anche le immagini già fallite prima che il listener fosse attivo.
 */
(function () {
  'use strict';

  var CDN = /(\/cdn\/shop\/|cdn\.shopify\.com\/)/;

  // Riscrive un singolo URL del CDN Shopify a format=pjpg. Altri URL invariati.
  function toPjpg(url) {
    if (!url || !CDN.test(url) || /[?&]format=pjpg\b/.test(url)) return url;
    if (/[?&]format=[a-z]+/i.test(url)) return url.replace(/([?&])format=[a-z]+/gi, '$1format=pjpg');
    var hash = url.indexOf('#');
    var base = hash >= 0 ? url.slice(0, hash) : url;
    var tail = hash >= 0 ? url.slice(hash) : '';
    return base + (base.indexOf('?') >= 0 ? '&' : '?') + 'format=pjpg' + tail;
  }

  // srcset: "url 165w, url 360w" -> riscrive solo la parte URL di ogni voce.
  function srcsetToPjpg(srcset) {
    return srcset.split(',').map(function (part) {
      var p = part.trim().split(/\s+/);
      p[0] = toPjpg(p[0]);
      return p.join(' ');
    }).join(', ');
  }

  function guardImg(img) {
    if (img.dataset.galaWebpGuarded === '1') return; // già gestita
    var src = img.getAttribute('src') || '';
    var srcset = img.getAttribute('srcset') || '';
    var newSrc = toPjpg(src);
    var newSrcset = srcset ? srcsetToPjpg(srcset) : '';
    if (newSrc === src && newSrcset === srcset) return;
    img.dataset.galaWebpGuarded = '1';
    if (newSrcset !== srcset) img.setAttribute('srcset', newSrcset);
    if (newSrc !== src) img.setAttribute('src', newSrc);
    if (window.console && console.warn) {
      console.warn('[gala-webp-jxl-guard] riscritto a pjpg:', src);
    }
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { toPjpg: toPjpg, srcsetToPjpg: srcsetToPjpg };
  }
  if (typeof document === 'undefined') return;

  // Handler capture: intercetta ogni error su img nell'intera pagina
  document.addEventListener('error', function (e) {
    var t = e.target;
    if (!t || t.tagName !== 'IMG') return;
    guardImg(t);
  }, true);

  // Immagini fallite prima che il listener fosse attivo
  window.addEventListener('load', function () {
    var imgs = document.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].complete && imgs[i].naturalWidth === 0 && imgs[i].getAttribute('src')) guardImg(imgs[i]);
    }
  });
})();
